// =============================================================================
// state
// =============================================================================
const state = {
  selectedTabId: 1,
  tableScrollTop1: 0,
  tableScrollTop2: 0,
  tableScrollTop3: 0,
  tableScrollTop4: 0,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  selected_tab_id: state => state.selectedTabId,
  table_scroll_top1: state => state.tableScrollTop1,
  table_scroll_top2: state => state.tableScrollTop2,
  table_scroll_top3: state => state.tableScrollTop3,
  table_scroll_top4: state => state.tableScrollTop4,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_selected_tab_id (state, value) {
    state.selectedTabId = value;
  },
  set_table_scroll_top1 (state, value) {
    state.tableScrollTop1 = value;
  },
  set_table_scroll_top2 (state, value) {
    state.tableScrollTop2 = value;
  },
  set_table_scroll_top3 (state, value) {
    state.tableScrollTop3 = value;
  },
  set_table_scroll_top4 (state, value) {
    state.tableScrollTop4 = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
